import { Box, ButtonNew, Loader, Spacer, Text, TextNew } from '@jfs/ui-new'
import { getLoadingState } from '@jfs/utils'
import { observer } from 'mobx-react'
import { FC, ReactElement, useEffect, useLayoutEffect, useState } from 'react'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import Tabbar, { TabbarType } from '../../comps/Tabbar/'
import { profileStrings, staticStrings } from '../../data/static/strings'
import { useLazyApiData, useStores } from '../../data/store'
import { useWindowDimensions } from '../../util/util'
import Business from './Business'
import Finance from './Finance'
import Notification from './Notification'
import Personal from './Personal'
import { styles } from './styles'

const retryView = (apiError: string, selectedMid: string, getMerchants: any, themedStyle: any): ReactElement => {
  const handleRetryPress = (): void => {
    if (selectedMid) {
      getMerchants(selectedMid)
    }
  }
  return (
    <Box {...themedStyle.retryViewStyle}>
      <ModBox>
        <TextNew type={'bodyMedium14'} color={'ERROR'}>
          {apiError}
        </TextNew>
      </ModBox>
      <Spacer size={20} />
      <ButtonNew
        testID={'profileRetry'}
        type={'secondary'}
        height={'36px'}
        width={'220px'}
        title={profileStrings.retry}
        onPress={handleRetryPress}
      />
    </Box>
  )
}

const getLoaderView = (themedStyle: any): ReactElement => {
  return (
    <Box {...themedStyle.loaderView}>
      <Loader type="large" color={'BLUE_SHADE'} />
    </Box>
  )
}

const Profile: FC = () => {
  const {
    selectedMid,
    merchant,
    canViewMobileNumber,
    canViewTransactionLimit,
    canViewSettlementBankDetails,
    searchEntity,
  } = useStores((store) => ({
    searchEntity: store?.user?.searchEntity,
    selectedMid: store?.user?.selectedMid,
    merchant: store?.getSelectedMerchant(),
    canViewMobileNumber: store.userManagement.canViewMobileNumber(),
    canViewTransactionLimit: store.userManagement.canViewTransactionLimit(),
    canViewSettlementBankDetails: store.userManagement.canViewSettlementBankDetails(),
  }))

  const [searchEntityApi, searchHandler] = useLazyApiData(searchEntity)

  const data = [
    { title: profileStrings.personal },
    { title: profileStrings.business },
    { title: profileStrings.finance },
    { title: profileStrings.notification },
  ]

  const apiError = searchHandler?.data?.message || ''

  useEffect(() => {
    if (selectedMid && apiError.length === 0) {
      searchEntityApi(selectedMid)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMid])

  const viewPortWidth = useWindowDimensions()

  const themedStyle = styles(viewPortWidth)

  const [value, setValue] = useState({ id: 0, text: '' })

  useLayoutEffect(() => {
    let title = ''
    if (canViewMobileNumber) {
      title = profileStrings.personal
    } else {
      title = profileStrings.business
    }
    setValue({ id: 0, text: title })
  }, [canViewMobileNumber])

  if (!canViewMobileNumber) {
    data?.splice(0, 1)
  }

  if (getLoadingState([searchHandler])) {
    return getLoaderView(themedStyle)
  }

  if (apiError && apiError.length > 0) {
    return retryView(apiError, selectedMid, searchEntityApi, themedStyle)
  }

  const selectedHandler = (index: number, titleText: string | undefined): void => {
    setValue({ id: index, text: titleText })
  }

  return (
    <Box {...themedStyle.container}>
      <Text fontFamily="jiotype-medium" testID="header" fontWeight="400" fontSize={20}>
        {staticStrings.myAccount}
      </Text>
      <Box {...themedStyle.tabbar} testID="tabbar">
        <Tabbar default={value?.id} titles={data} onSelected={selectedHandler} type={TabbarType.profile} />
      </Box>
      <Spacer size={viewPortWidth < 1000 ? 16 : 40} />
      <Personal hide={!(value?.text === profileStrings.personal && canViewMobileNumber)} data={merchant} />
      <Business hide={!(value?.text === profileStrings.business)} data={merchant} />
      <Finance
        canViewTransactionLimit={canViewTransactionLimit}
        canViewSettlementBankDetails={canViewSettlementBankDetails}
        hide={!(value?.text === profileStrings.finance)}
        data={merchant}
      />
      <Notification hide={!(value?.text === profileStrings.notification)} data={merchant} />
      <Text color="CLOUDY_GREY" fontSize={12} fontWeight="BOLD">
        {'For any change in Profile Section please connect with Support Team'}
      </Text>
    </Box>
  )
}
export default observer(Profile)
